<template>
    <section>
        <div class="contact_section2" style="display: flex; position: relative;">
            <div class="mobile_con_wrap" style="padding-top: 112px; padding-bottom: 180px;">
                <div data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out"  style="display: flex; justify-content: flex-start; flex-direction: column;">
                    <p style="font-size: 25px; font-weight: 700; color: black; margin-bottom: 50px;">제휴 문의</p> 
                    <div style="font-weight: 400; font-size: 15px; color: #5A5A5A">
                        <p style="margin-bottom: 30px; line-height: 1.5;">
                            경기도 안양시 동안구 시민대로 327번길 11-41,<br>5층 507호<br>
                            5F, 11-41, Simin-daero 327bean-gil, Dongan-gu,
                            Anyang-si, Gyeonggi-do, Republic Korea
                        </p> 
                        <p @click="copy(adminEmail)" style="line-height: 1.8; text-decoration: underline; cursor: pointer;">
                            {{adminEmail}}
                            <span>
                                <img src="@/assets/images/icon/icon-copy.svg" alt="">
                            </span>
                        </p> 
                    </div>
                </div>
            </div>
            <transition name="fade" appear>
                <div v-if="showSnackBar" style="width: 200px; text-align: center; position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); border-radius: 10px; padding: 10px 12px; background: #000000B3; color: white;">
                    메일주소가 복사되었습니다
                </div>
            </transition>
        </div>
        <!-- <SnackBar v-if="showSnackBar" :info="snackbarInfo" @close="showSnackBar = false" /> -->
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
import SnackBar from '@/components/SnackBar.vue'
export default {
    components: {
        ChevronDownIcon,
        SnackBar
    },
    data() {
        return {
            webUrl: "https://www.pulda.net/main",
            appleUrl: "https://apps.apple.com/app/id1530892838",
            googleUrl:
                "https://play.google.com/store/apps/details?id=com.filledu.pulda2",
            adminEmail: 'mesen@filledyou.com',
            showSnackBar: false,
            snackbarInfo: {
                text: '',
                icon: '',
                color: '',
                background: ''
            },
        }
    },
    methods: {
        openLink(val) {
            window.open(val, '_blank')
        },
        copy(val) {
            const textArea = document.createElement("textarea");
            textArea.value = val;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Unable to copy to clipboard', err);
            }
            document.body.removeChild(textArea);
            this.showSnackBar = true
            setTimeout(() => {
                this.showSnackBar = false
            }, 1500)
        },
    }
    
}
</script>
<style>
    .contact_section2 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
</style>